import { useSearchParams, useLocation } from "react-router-dom";
import { useState, useEffect } from "react";
import camisas from "../data/camisas";
import CardCamisa from "../components/CardCamisa/CardCamisa";
import ModalCamisa from "../components/ModalCamisa/ModalCamisa";

export default function Busca() {
  const [params] = useSearchParams();
  const location = useLocation();

  const termo = params.get("q") || "";
  const [camisaSelecionada, setCamisaSelecionada] = useState(null);

  useEffect(() => {
    setCamisaSelecionada(null);
  }, [location.search]);

  // const resultados = camisas.filter((c) =>
  //   c.nome.toLowerCase().includes(termo.toLowerCase())
  // );

  function normalize(text = "") {
    return text
      .toLowerCase()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "");
  }

  const termoNormalizado = normalize(termo);

  const resultados = camisas.filter((c) => {
    const nome = normalize(c.nome);

    const aliases = (c.aliases || []).map(normalize);

    return (
      nome.includes(termoNormalizado) ||
      aliases.some((a) => a.includes(termoNormalizado))
    );
  });

  return (
    <div className="container">
      <h1 className="page-title">
        Resultado da busca para:{" "}
        <span style={{ color: "#22c55e" }}>{termo}</span>
      </h1>

      {resultados.length === 0 ? (
        <p style={{ color: "#9ca3af" }}>Nenhuma camisa encontrada.</p>
      ) : (
        <div className="grid">
          {resultados.map((camisa) => (
            <CardCamisa
              key={camisa.id}
              camisa={camisa}
              onClick={setCamisaSelecionada}
            />
          ))}
        </div>
      )}
      {camisaSelecionada && (
        <ModalCamisa
          camisa={camisaSelecionada}
          onClose={() => setCamisaSelecionada(null)}
        />
      )}
    </div>
  );
}
